<template>
  <MonitorWrapper class-name="fit-rm">
    <info-block title="实时状态">
      <template #titleRight>
        <div class="fit-pos">
          <span>经度: {{ fitRm.longitude }}</span>
          <span>纬度: {{ fitRm.latitude }}</span>
          <span>蓝牙连接状态：{{ fitRm.bluetoothState | btState }}</span>
          <span>设备电量: {{ fitRm.powerPercent }}%</span>
        </div>
      </template>
      <template #content>
        <div class="fit-content">
          <el-row class="fit-info">
            <el-col :span="10">
              <ModsIcon
                showText
                :alarmState="fitRm.alarmState"
                :alarmDic="['未报警', '伽马报警', '中字报警']"
                width="120px"
                icon="icon-he"
                :wsData="wsData"
                :mods="curMod"
              />
            </el-col>
            <el-col :span="14">
              <el-col :span="8">
                <div>
                  <span>伽马剂量率(μSv/h):</span>
                  <span>{{ fitRm.radDose }}</span>
                </div>
                <div>
                  <span>伽马计数率(CPS):</span>
                  <span>{{ fitRm.radDoseCount }}</span>
                </div>
                <div>
                  <span>中子数(CPS):</span>
                  <span>{{ fitRm.neutronCount }}</span>
                </div>
              </el-col>
              <el-col :span="16">
                <div>
                  <span>核素名称:</span>
                  <span>{{ fitRm.nuclideName }}</span>
                </div>
                <div>
                  <span>识别结果概率:</span>
                  <span>{{ fitRm.nuclideProbability }}%</span>
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-divider style="padding: 0 20px"></el-divider>
          <el-row class="fit-chart" :gutter="20">
            <el-col :span="12">
              <div style="overflow: hidden">
                <v-chart :options="radOp" :autoresize="true"></v-chart>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="overflow: hidden">
                <v-chart :options="neuOp" :autoresize="true"></v-chart>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </info-block>
    <el-dialog :visible.sync="alarmVisible" width="70%" title="能谱图">
      <el-row :gutter="20">
        <el-col :span="12">
          <div style="height: 500px; overflow: hidden">
            <v-chart :options="radAlarmOp" :autoresize="true"></v-chart>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="height: 500px; overflow: hidden">
            <v-chart :options="neuAlarmOp" :autoresize="true"></v-chart>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import InfoBlock from '../components/info-block';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import ModsIcon from '@/components/mods-icon';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

export default {
  name: 'fitRm',
  components: {
    InfoBlock,
    ModsIcon
  },
  mixins: [singleDeviceMixin],
  filters: {
    btState(bt) {
      const btDic = ['未连接', '正在连接', '连接正常'];
      return btDic[bt] || '未连接';
    }
  },
  data() {
    return {
      alarmVisible: false,
      radOp: lineAreaStyle({
        color: '#2aa9c1',
        title: {
          text: '伽马剂量率',
          left: 'center',
          textStyle: { color: '#00eeff', fontSize: 20 }
        },
        yAxis: { name: 'μSv/h' },
        series: [{ areaStyle: { color: graColor('rgb(45, 172, 192)', 'rgba(25, 136, 179, 0.2)') } }]
      }),
      neuOp: lineAreaStyle({
        color: '#2aa9c1',
        title: {
          text: '中子数',
          left: 'center',
          textStyle: { color: '#00eeff', fontSize: 20 }
        },
        yAxis: { name: 'CPS' },
        series: [{ areaStyle: { color: graColor('rgb(45, 172, 192)', 'rgba(25, 136, 179, 0.2)') } }]
      }),
      fitRm: {},
      wsData: {},
      curMod: 'nuclearMod'
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    radAlarmOp() {
      return lineAreaStyle({
        color: '#2aa9c1',
        title: {
          text: '伽马剂量率',
          left: 'center',
          textStyle: { color: '#00eeff', fontSize: 20 }
        },
        yAxis: { name: 'μSv/h' },
        series: [
          {
            areaStyle: { color: graColor('rgb(45, 172, 192)', 'rgba(25, 136, 179, 0.2)') },
            data: this.fitRm.spectrumTracks || []
          }
        ]
      });
    },
    neuAlarmOp() {
      return lineAreaStyle({
        color: '#2aa9c1',
        title: {
          text: '中子数',
          left: 'center',
          textStyle: { color: '#00eeff', fontSize: 20 }
        },
        yAxis: { name: 'CPS' },
        series: [
          {
            areaStyle: { color: graColor('rgb(45, 172, 192)', 'rgba(25, 136, 179, 0.2)') },
            data: this.fitRm.neutronTracks || []
          }
        ]
      });
    }
  },
  methods: {
    updateData(newVal) {
      const { beginTime } = newVal;
      const { fitRm } = newVal.mods[this.curMod];
      this.fitRm = fitRm;
      this.wsData = newVal;
      this.radOp.series[0].data.push([beginTime, fitRm.radDose]);
      this.neuOp.series[0].data.push([beginTime, fitRm.neutronCount]);
      if (this.radOp.series[0].data.length > 20) {
        this.radOp.series[0].data.shift();
        this.neuOp.series[0].data.shift();
      }
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.wsData = this.historyDetailData;
        this.fitRm = this.historyDetailData.mods[this.curMod].fitRm;
        this.historyDetailDatas.forEach(ele => {
          this.radOp.series[0].data.push([ele.beginTime, ele.mods[this.curMod].fitRm.radDose]);
          this.neuOp.series[0].data.push([ele.beginTime, ele.mods[this.curMod].fitRm.neutronCount]);
        });
        this.hideLoading();
      }
    },
    showAlarm() {
      if (this.fitRm.alarmState > 0) {
        this.alarmVisible = true;
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss" scoped>
.fit-rm {
  height: 100%;
  .fit-pos {
    span {
      display: inline-block;
      min-width: 80px;
      margin: 0 8px;
    }
  }
  .fit-content {
    height: calc(100% - 55px);
    .el-row {
      &.fit-info {
        height: 35%;
        > .el-col {
          display: flex;
          align-items: center;
          &:first-child {
            flex-direction: column;
            justify-content: center;
          }
          span {
            font-size: 18px;
            line-height: 34px;
            letter-spacing: 2px;
          }
        }
      }
      &.fit-chart {
        height: 65%;
        div {
          height: 100%;
        }
      }
      > .el-col {
        height: 100%;
      }
    }
  }
}
</style>
